// extracted by mini-css-extract-plugin
module.exports = {"Section1":"Section1_Section1__gqlLO","ImageList":"Section1_ImageList__hn_m4"};